<template>
  <div>
    <top-navbar></top-navbar>

    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/">Home</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        <router-link class="decoration" to="/projectmanagement/visitindex"> Visit Reporting</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        Visit Schedule
      </h6>

      <div class="container-fluid" style="padding-bottom: 70px;">
        <div class="card bdr-rad2 mt-1 shadow p-2">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-start flex-wrap mb-3">
              <div>
                <h5 class="mb-1">Visit Schedule</h5>
              </div>
            </div>

            <form @submit.prevent="saveVisitReport">
              <div class="row">
                <div class="col-md-3">
                  <div class="form-group required">
                    <label class="custom-label" style="font-size: small;">Select Project</label>
                    <select
                      v-model="form.project_id"
                      class="form-control bdr-rad font-size_def"
                      required
                      @change="handleProjectChange"
                    >
                      <option value="">- Select Project -</option>
                      <option v-for="item in projectOptions" :key="item.value" :value="item.value">
                        {{ item.label }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="form-group">
                    <label class="custom-label" style="font-size: small;">Site</label>
                    <input
                      :value="form.site"
                      type="text"
                      class="form-control bdr-rad font-size_def"
                      placeholder="Site will auto load"
                      readonly
                    />
                  </div>
                </div>

                  <div class="col-md-3">
                  <div class="form-group">
                    <label class="custom-label" style="font-size: small;">Screening Date</label>
                    <input
                      :value="formatDate(form.screening_date)"
                      type="text"
                      class="form-control bdr-rad font-size_def"
                      placeholder="Screening date will auto load"
                      readonly
                    />
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="form-group">
                    <label class="custom-label" style="font-size: small;">Select Patient</label>
                    <div class="d-flex align-items-start">
                      <select
                        v-model="form.patient_id"
                        class="form-control bdr-rad font-size_def"
                        :disabled="!form.project_id"
                        @change="handlePatientChange"
                      >
                        <option value="">- Select Patient -</option>
                        <option v-for="item in patientOptions" :key="item.value" :value="item.value">
                          {{ item.label }}
                        </option>
                      </select>
                      <button
                        type="button"
                        class="btn btn-outline-primary ml-2 font-size_def bdr-rad"
                        :disabled="!form.project_id || creatingPatient"
                        @click="createPatient"
                      >
                        {{ creatingPatient ? "..." : "New" }}
                      </button>
                    </div>
                  </div>
                </div>

              
              </div>

              <div class="row">
                <div class="col-md-3">
                  <div class="form-group">
                    <label class="custom-label" style="font-size: small;">Select Investigators</label>
                    <v-select
                      v-model="form.investigators"
                      :options="availableInvestigatorOptions"
                      label="label"
                      class="font-size_def activity-select"
                      multiple
                      placeholder="- Select Investigator -"
                    >
                      <template #selected-option-container>
                        <span></span>
                      </template>
                    </v-select>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="form-group">
                    <label class="custom-label" style="font-size: small;">Select Investigator Team</label>
                    <div class="investigator-list-box">
                      <div
                        v-for="(name, index) in investigatorNames"
                        :key="index"
                        class="d-flex align-items-center mb-2 investigator-list-item"
                      >
                        <button
                          type="button"
                          class="btn btn-link btn-sm investigator-remove-btn"
                          aria-label="Remove investigator"
                          @click="removeInvestigator(name)"
                        >
                          X
                        </button>
                        <div style="font-size: small;">
                          {{ name }}
                        </div>
                      </div>
                      <div v-if="!investigatorNames.length" class="text-muted" style="font-size: small;">
                        Select project to load investigators.
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card custom_bdr_rds shadow p-2 mt-2">
                <div class="card-body custom_bdr_rds">
                  <div class="mb-2">
                    <div class="visit-schedule-banner" style="background:#007bff;color:#fff;padding:5px 8px;border-radius:4px;width:100%;display:block;font-size:12px;line-height:1.2;">
                      <b>Visit Schedule</b>
                    </div>
                    <!-- <div v-if="projectDetails.project_name" class="text-muted mt-1" style="font-size: small;">
                      {{ projectDetails.project_name }}
                    </div> -->
                  </div>

                  <div class="table-responsive">
                    <table style="font-size: small;" class="table table-hover table-sm table-borderless">
                      <thead class="background_color2">
                        <tr class="custom-label2">
                          <th style="width: 8%;">#</th>
                          <th style="width: 28%;">Description</th>
                          <th style="width: 13%;">Date</th>
                          <th style="width: 13%;">Allowed Deviation +/- Days</th>
                          <th style="width: 16%;">Visit Date</th>
                          <th style="width: 11%;">SAE Tracker</th>
                          <th style="width: 11%;">PD Tracker</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(visit, index) in form.visits" :key="index">
                          <td>{{ visit.visit_number }}</td>
                          <td>{{ getVisitDescription(visit, index) }}</td>
                          <td>{{ formatDate(visit.date) }}</td>
                          <td>{{ formatDeviation(visit.allowed_deviation_days) }}</td>
                          <td>
                            <input
                              v-model="visit.visit_date"
                              type="date"
                              class="form-control bdr-rad font-size_def"
                              :min="visit.min_date || null"
                              :max="visit.max_date || null"
                              @input="validateVisitRow(index)"
                            />
                            <small
                              v-if="visit.validation_message"
                              class="text-danger d-block mt-1"
                            >
                              {{ visit.validation_message }}
                            </small>
                            <small
                              v-else-if="visit.min_date || visit.max_date"
                              class="text-muted d-block mt-1"
                            >
                              Valid range: {{ formatDate(visit.min_date) }} - {{ formatDate(visit.max_date) }}
                            </small>
                          </td>
                          <td>
                            <button
                              type="button"
                              class="btn btn-outline-primary btn-sm bdr-rad font-size_def w-100"
                              @click="openSaeModal(index)"
                            >
                              SAE<span v-if="visit.sae_entries && visit.sae_entries.length"> ({{ visit.sae_entries.length }})</span>
                            </button>
                          </td>
                          <td>
                            <button
                              type="button"
                              class="btn btn-outline-primary btn-sm bdr-rad font-size_def w-100"
                              @click="openPdModal(index)"
                            >
                              PD<span v-if="visit.rpd_entries && visit.rpd_entries.length"> ({{ visit.rpd_entries.length }})</span>
                            </button>
                          </td>
                        </tr>
                        <tr v-if="!form.visits.length">
                          <td colspan="7" class="text-center text-muted py-3">
                            Select project to load visit schedule.
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div v-if="previewMessage" class="alert alert-success mt-4 mb-0" role="alert">
                {{ previewMessage }}
              </div>

              <div v-if="errorMessage" class="alert alert-danger mt-4 mb-0" role="alert">
                {{ errorMessage }}
              </div>

              <div style="border-bottom: 0px; padding-top: 0px;" class="navbar mt-3">
                <div class="d-flex"></div>
                <div class="d-flex">
                  <button
                    type="button"
                    class="mr-1 btn btn-outline-secondary mb-1 font-size_def bdr-rad"
                    @click="resetForm"
                  >
                    Clear
                  </button>
                  <button
                    type="submit"
                    class="mr-1 btn btn-outline-primary mb-1 font-size_def bdr-rad"
                    :disabled="saving || !form.project_id || !form.visits.length"
                  >
                    {{ saving ? "Saving..." : "Save Visit Report" }}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      v-model="saeModalOpen"
      size="xl"
      hide-footer
      title="SAE Tracker"
      no-close-on-backdrop
      @hidden="resetSaeDraft"
    >
      <div v-if="activeSaeVisit">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <div style="font-size: small;">
            <b>Visit:</b> {{ activeSaeVisit.visit_number }}
            <span class="ml-2"><b>Description:</b> {{ getVisitDescription(activeSaeVisit, activeSaeVisitIndex) }}</span>
          </div>
        </div>

        <div v-if="saeDraftEntries.length">
          <div
            v-for="(entry, entryIndex) in saeDraftEntries"
            :key="entryIndex"
            class="tracker-card mb-3"
          >
            <div class="tracker-card-header">
              <div><b>SAE Row {{ entryIndex + 1 }}</b></div>
              <div class="d-flex align-items-center">
                <button
                  v-if="entryIndex > 0"
                  type="button"
                  class="btn btn-link btn-sm text-danger p-0 action-icon-btn"
                  @click="removeSaeRow(entryIndex)"
                >
                  X
                </button>
                <button
                  v-if="entryIndex === saeDraftEntries.length - 1"
                  type="button"
                  class="btn btn-link btn-sm text-primary p-0 ml-3 action-icon-btn"
                  @click="addSaeRow"
                >
                  +
                </button>
              </div>
            </div>

            <div class="tracker-card-body">
              <div class="row">
                <div class="col-md-3">
                  <div class="form-group mb-2">
                    <label class="tracker-label">Date of Awareness</label>
                    <input
                      :value="entry.date_of_awareness"
                      type="date"
                      class="form-control bdr-rad font-size_def"
                      @input="updateSaeAwareness(entryIndex, $event.target.value)"
                    />
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group mb-2">
                    <label class="tracker-label">SAE Serial Number</label>
                    <input
                      :value="entry.sae_serial_number"
                      type="text"
                      class="form-control bdr-rad font-size_def"
                      readonly
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group mb-2">
                    <label class="tracker-label">Patient Number</label>
                    <input
                      v-model="entry.patient_number"
                      type="text"
                      class="form-control bdr-rad font-size_def"
                    />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group mb-2">
                    <label class="tracker-label">Status</label>
                    <input
                      v-model="entry.status"
                      type="text"
                      class="form-control bdr-rad font-size_def"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="form-group mb-2">
                    <label class="tracker-label">Event Term</label>
                    <textarea
                      v-model="entry.event_term"
                      class="form-control bdr-rad font-size_def"
                      rows="3"
                    ></textarea>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-3">
                  <div class="form-group mb-2">
                    <label class="tracker-label">Start Date</label>
                    <input
                      v-model="entry.start_date"
                      type="date"
                      class="form-control bdr-rad font-size_def"
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group mb-2">
                    <label class="tracker-label">End date</label>
                    <input
                      v-model="entry.end_date"
                      type="date"
                      class="form-control bdr-rad font-size_def"
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group mb-2">
                    <label class="tracker-label">Report Date Initial</label>
                    <input
                      v-model="entry.report_date_initial"
                      type="date"
                      class="form-control bdr-rad font-size_def"
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group mb-2">
                    <label class="tracker-label">Report Date Follow-up</label>
                    <input
                      v-model="entry.report_date_follow_up"
                      type="date"
                      class="form-control bdr-rad font-size_def"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-else class="text-center text-muted py-3 tracker-empty-state">
          No SAE rows added.
        </div>

        <div class="d-flex justify-content-end mt-3">
          <button
            type="button"
            class="btn btn-outline-primary btn-sm bdr-rad font-size_def"
            @click="submitSaeModal"
          >
            Submit
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal
      v-model="pdModalOpen"
      size="xl"
      hide-footer
      title="PD Tracker"
      no-close-on-backdrop
      @hidden="resetPdDraft"
    >
      <div v-if="activePdVisit">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <div style="font-size: small;">
            <b>Visit:</b> {{ activePdVisit.visit_number }}
            <span class="ml-2"><b>Description:</b> {{ getVisitDescription(activePdVisit, activePdVisitIndex) }}</span>
          </div>
        </div>

        <div v-if="pdDraftEntries.length">
          <div
            v-for="(entry, entryIndex) in pdDraftEntries"
            :key="entryIndex"
            class="tracker-card mb-3"
          >
            <div class="tracker-card-header">
              <div><b>PD Row {{ entryIndex + 1 }}</b></div>
              <div class="d-flex align-items-center">
                <button
                  v-if="entryIndex > 0"
                  type="button"
                  class="btn btn-link btn-sm text-danger p-0 action-icon-btn"
                  @click="removePdRow(entryIndex)"
                >
                  X
                </button>
                <button
                  v-if="entryIndex === pdDraftEntries.length - 1"
                  type="button"
                  class="btn btn-link btn-sm text-primary p-0 ml-3 action-icon-btn"
                  @click="addPdRow"
                >
                  +
                </button>
              </div>
            </div>

            <div class="tracker-card-body">
              <div class="row">
                <div class="col-md-3">
                  <div class="form-group mb-2">
                    <label class="tracker-label">PD Identified Date</label>
                    <input
                      :value="entry.pd_identified_date"
                      type="date"
                      class="form-control bdr-rad font-size_def"
                      readonly
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group mb-2">
                    <label class="tracker-label">Date of Occurrence</label>
                    <input v-model="entry.date_of_occurrence" type="date" class="form-control bdr-rad font-size_def" />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group mb-2">
                    <label class="tracker-label">Subject No</label>
                    <input v-model="entry.subject_no" type="text" class="form-control bdr-rad font-size_def" />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group mb-2">
                    <label class="tracker-label">Status (Major/Minor)</label>
                    <select v-model="entry.status" class="form-control bdr-rad font-size_def">
                      <option value="">- Select -</option>
                      <option value="Major">Major</option>
                      <option value="Minor">Minor</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group mb-2">
                    <label class="tracker-label">Description of Protocol Deviation</label>
                    <textarea v-model="entry.protocol_deviation_description" class="form-control bdr-rad font-size_def" rows="3"></textarea>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group mb-2">
                    <label class="tracker-label">Corrective/ Preventive Action Taken</label>
                    <textarea v-model="entry.corrective_action_taken" class="form-control bdr-rad font-size_def" rows="3"></textarea>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <div class="form-group mb-2">
                    <label class="tracker-label">Reference number</label>
                    <input v-model="entry.reference_number" type="text" class="form-control bdr-rad font-size_def" />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group mb-2">
                    <label class="tracker-label">No of similar events</label>
                    <input v-model="entry.similar_events_count" type="number" min="0" class="form-control bdr-rad font-size_def" />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group mb-2">
                    <label class="tracker-label">Status of submission</label>
                    <input v-model="entry.submission_status" type="text" class="form-control bdr-rad font-size_def" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-else class="text-center text-muted py-3 tracker-empty-state">
          No PD rows added.
        </div>

        <div class="d-flex justify-content-end mt-3">
          <button
            type="button"
            class="btn btn-outline-primary btn-sm bdr-rad font-size_def"
            @click="submitPdModal"
          >
            Submit
          </button>
        </div>
      </div>
    </b-modal>

    <content-footer></content-footer>
  </div>
</template>

<script>
import axios from "axios";
import authService from "@/auth.service";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import TopNavbar from "./../../layout/TopNavbar.vue";
import ContentFooter from "./../../layout/ContentFooter.vue";

function createForm() {
  return {
    project_id: "",
    patient_id: "",
    site: "",
    screening_date: "",
    report_batch_code: "",
    investigators: [],
    visits: [],
  };
}

export default {
  components: {
    vSelect,
    TopNavbar,
    ContentFooter,
  },

  data() {
    return {
      access_token: authService.isLoggedIn(),
      userid: authService.isUserid(),
      form: createForm(),
      projectOptions: [],
      patientOptions: [],
      projectInvestigatorOptions: [],
      projectInvestigatorOptions: [],
      projectDetails: {
        project_name: "",
        visit_schedule: [],
      },
      previewMessage: "",
      errorMessage: "",
      saving: false,
      creatingPatient: false,
      saeModalOpen: false,
      activeSaeVisitIndex: null,
      saeDraftEntries: [],
      pdModalOpen: false,
      activePdVisitIndex: null,
      pdDraftEntries: [],
    };
  },

  computed: {
    investigatorNames() {
      return this.form.investigators.map((item) => item.label);
    },
    selectedInvestigatorOptions() {
      return this.investigatorNames.map((name) => ({
        label: name,
        value: name,
      }));
    },
    availableInvestigatorOptions() {
      const selectedValues = new Set(this.form.investigators.map((item) => item.value));
      return this.projectInvestigatorOptions.filter((item) => !selectedValues.has(item.value));
    },
    activeSaeVisit() {
      if (this.activeSaeVisitIndex === null || typeof this.activeSaeVisitIndex === "undefined") {
        return null;
      }

      return this.form.visits[this.activeSaeVisitIndex] || null;
    },
    activePdVisit() {
      if (this.activePdVisitIndex === null || typeof this.activePdVisitIndex === "undefined") {
        return null;
      }

      return this.form.visits[this.activePdVisitIndex] || null;
    },
  },

  mounted() {
    this.loadProjectOptions();
  },

  methods: {
    resetForm() {
      this.form = createForm();
      this.projectDetails = {
        project_name: "",
        visit_schedule: [],
        investigator_names: [],
      };
      this.patientOptions = [];
      this.projectInvestigatorOptions = [];
      this.previewMessage = "";
      this.errorMessage = "";
    },

    buildInvestigatorOptions(names) {
      return Array.from(
        new Set(
          (Array.isArray(names) ? names : [])
            .map((name) => String(name || "").trim())
            .filter((name) => name !== "")
        )
      ).map((name) => ({
        label: name,
        value: name,
      }));
    },

    applyInvestigatorSelection(names) {
      const mergedOptions = this.buildInvestigatorOptions([
        ...this.projectInvestigatorOptions.map((item) => item.label),
        ...(Array.isArray(names) ? names : []),
      ]);

      this.projectInvestigatorOptions = mergedOptions;

      const selectedNames = new Set(
        (Array.isArray(names) ? names : [])
          .map((name) => String(name || "").trim())
          .filter((name) => name !== "")
      );

      this.form.investigators = this.projectInvestigatorOptions.filter((item) => selectedNames.has(item.label));
    },

    formatDate(value) {
      if (!value) {
        return "-";
      }

      const [year, month, day] = String(value).split("-");
      return year && month && day ? `${day}/${month}/${year}` : value;
    },

    removeInvestigator(name) {
      this.form.investigators = this.form.investigators.filter((item) => item.label !== name);
    },

    formatDeviation(value) {
      if (value === null || typeof value === "undefined" || value === "") {
        return "-";
      }

      const normalized = String(value).trim();

      if (!normalized) {
        return "-";
      }

      if (normalized === "0" || normalized === "+0" || normalized === "-0" || normalized === "+/- 0") {
        return "-";
      }

      if (normalized.startsWith("+") || normalized.startsWith("-")) {
        return normalized;
      }

      const parsed = parseInt(normalized, 10);

      if (Number.isNaN(parsed)) {
        return normalized;
      }

      return parsed > 0 ? `+${parsed}` : String(parsed);
    },

    getVisitDescription(visit, index) {
      const description = visit && visit.description ? String(visit.description).trim() : "";
      const label = visit && visit.treatment_phase_label ? String(visit.treatment_phase_label).trim() : "";

      if (label && description) {
        return `${label} - ${description}`;
      }

      if (label) {
        return label;
      }

      if (description) {
        return description;
      }

      return "-";
    },

    parseDeviationRange(value) {
      if (value === null || typeof value === "undefined" || value === "") {
        return { minOffset: 0, maxOffset: 0 };
      }

      const normalized = String(value).trim();

      if (!normalized) {
        return { minOffset: 0, maxOffset: 0 };
      }

      const match = normalized.match(/-?\d+/);
      const parsed = match ? parseInt(match[0], 10) : 0;

      if (Number.isNaN(parsed)) {
        return { minOffset: 0, maxOffset: 0 };
      }

      if (
        normalized.startsWith("+/-") ||
        normalized.startsWith("+ / -") ||
        normalized.startsWith("+/") ||
        normalized.startsWith("+ /") ||
        normalized.startsWith("-/+") ||
        normalized.startsWith("- / +")
      ) {
        return {
          minOffset: -Math.abs(parsed),
          maxOffset: Math.abs(parsed),
        };
      }

      if (normalized.startsWith("-")) {
        return { minOffset: parsed, maxOffset: 0 };
      }

      if (normalized.startsWith("+")) {
        return { minOffset: 0, maxOffset: Math.abs(parsed) };
      }

      return {
        minOffset: -Math.abs(parsed),
        maxOffset: Math.abs(parsed),
      };
    },

    shiftDate(dateString, days) {
      if (!dateString && dateString !== 0) {
        return "";
      }

      const baseDate = new Date(String(dateString) + "T00:00:00");

      if (Number.isNaN(baseDate.getTime())) {
        return "";
      }

      baseDate.setDate(baseDate.getDate() + Number(days || 0));

      const year = baseDate.getFullYear();
      const month = String(baseDate.getMonth() + 1).padStart(2, "0");
      const day = String(baseDate.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },

    buildVisitRow(scheduleRow, index) {
      const scheduledDate = scheduleRow.date || "";
      const deviationRange = this.parseDeviationRange(scheduleRow.allowed_deviation_days);
      const minDate = this.shiftDate(scheduledDate, deviationRange.minOffset);
      const maxDate = this.shiftDate(scheduledDate, deviationRange.maxOffset);

      return {
        visit_number: index + 1,
        treatment_phase: scheduleRow.treatment_phase || "",
        treatment_phase_label: scheduleRow.treatment_phase_label || "",
        is_fixed_row: !!scheduleRow.is_fixed_row,
        description: scheduleRow.description || "",
        date: scheduledDate,
        allowed_deviation_days: scheduleRow.allowed_deviation_days || "",
        visit_date: scheduleRow.visit_date || "",
        sae_tracker: scheduleRow.sae_tracker || "",
        sae_entries: Array.isArray(scheduleRow.sae_entries) ? scheduleRow.sae_entries : [],
        rpd_tracker: scheduleRow.rpd_tracker || "",
        rpd_entries: Array.isArray(scheduleRow.rpd_entries) ? scheduleRow.rpd_entries : [],
        min_date: minDate,
        max_date: maxDate,
        validation_message: "",
      };
    },

    mergePatientVisits(baseSchedule, savedVisits) {
      const savedRows = Array.isArray(savedVisits) ? savedVisits : [];

      return baseSchedule.map((visit, index) => {
        const matchedVisit =
          savedRows.find((row) => String(row.visit_number || "") === String(visit.visit_number || "")) ||
          savedRows[index] ||
          null;

        if (!matchedVisit) {
          return {
            ...visit,
            validation_message: "",
          };
        }

        const candidateVisitDate = matchedVisit.visit_date || "";
        const validVisitDate =
          candidateVisitDate &&
          (!visit.min_date || candidateVisitDate >= visit.min_date) &&
          (!visit.max_date || candidateVisitDate <= visit.max_date)
            ? candidateVisitDate
            : "";

        return {
          ...visit,
          visit_date: validVisitDate,
          sae_tracker: matchedVisit.sae_tracker || "",
          sae_entries: Array.isArray(matchedVisit.sae_entries) ? matchedVisit.sae_entries : [],
          rpd_tracker: matchedVisit.rpd_tracker || "",
          rpd_entries: Array.isArray(matchedVisit.rpd_entries) ? matchedVisit.rpd_entries : [],
          validation_message: "",
        };
      });
    },

    createSaeEntry(visit) {
      return {
        date_of_awareness: visit && visit.visit_date ? visit.visit_date : "",
        sae_serial_number: "",
        patient_number: this.getSelectedPatientCode(),
        event_term: "",
        start_date: "",
        end_date: "",
        status: "",
        report_date_initial: "",
        report_date_follow_up: "",
      };
    },

    getSelectedPatientCode() {
      const selectedPatient = this.patientOptions.find((item) => String(item.value) === String(this.form.patient_id));
      return selectedPatient ? selectedPatient.code || selectedPatient.label || "" : "";
    },

    updateSaeSerialNumbers() {
      if (!this.activeSaeVisit) {
        return;
      }

      this.saeDraftEntries = this.saeDraftEntries.map((entry, index) => ({
        ...entry,
        sae_serial_number: index + 1,
        patient_number: entry.patient_number || this.getSelectedPatientCode(),
      }));
    },

    openSaeModal(index) {
      const visit = this.form.visits[index];

      if (!visit) {
        return;
      }

      if (!Array.isArray(visit.sae_entries)) {
        this.$set(visit, "sae_entries", []);
      }

      this.activeSaeVisitIndex = index;

      if (!visit.sae_entries.length) {
        this.saeDraftEntries = [this.createSaeEntry(visit)];
      } else {
        this.saeDraftEntries = visit.sae_entries.map((entry) => ({
          ...entry,
          date_of_awareness: entry.date_of_awareness || visit.visit_date || "",
          patient_number: entry.patient_number || this.getSelectedPatientCode(),
        }));
      }

      this.updateSaeSerialNumbers();
      this.saeModalOpen = true;
    },

    addSaeRow() {
      if (!this.activeSaeVisit) {
        return;
      }

      this.saeDraftEntries.push(this.createSaeEntry(this.activeSaeVisit));
      this.updateSaeSerialNumbers();
    },

    removeSaeRow(entryIndex) {
      if (!this.activeSaeVisit) {
        return;
      }

      this.saeDraftEntries.splice(entryIndex, 1);
      this.updateSaeSerialNumbers();
    },

    updateSaeAwareness(entryIndex, value) {
      if (!this.activeSaeVisit || !this.saeDraftEntries[entryIndex]) {
        return;
      }

      this.$set(this.saeDraftEntries[entryIndex], "date_of_awareness", value);
    },

    submitSaeModal() {
      if (!this.activeSaeVisit) {
        this.saeModalOpen = false;
        return;
      }

      this.$set(this.activeSaeVisit, "sae_entries", this.cloneEntries(this.saeDraftEntries));
      this.$set(this.activeSaeVisit, "sae_tracker", this.saeDraftEntries.length);
      this.saeModalOpen = false;
    },

    resetSaeDraft() {
      this.saeDraftEntries = [];
      this.activeSaeVisitIndex = null;
    },

    createPdEntry(visit) {
      return {
        pd_identified_date: visit && visit.visit_date ? visit.visit_date : "",
        date_of_occurrence: visit && visit.visit_date ? visit.visit_date : "",
        subject_no: this.getSelectedPatientCode(),
        protocol_deviation_description: "",
        corrective_action_taken: "",
        status: "",
        reference_number: "",
        similar_events_count: "",
        submission_status: "",
      };
    },

    updatePdTrackerCount() {
      if (!this.activePdVisit) {
        return;
      }

      this.pdDraftEntries = this.pdDraftEntries.map((entry) => ({
        ...entry,
      }));
    },

    openPdModal(index) {
      const visit = this.form.visits[index];

      if (!visit) {
        return;
      }

      if (!Array.isArray(visit.rpd_entries)) {
        this.$set(visit, "rpd_entries", []);
      }

      this.activePdVisitIndex = index;

      if (!visit.rpd_entries.length) {
        this.pdDraftEntries = [this.createPdEntry(visit)];
      } else {
        this.pdDraftEntries = visit.rpd_entries.map((entry) => ({
          ...entry,
          pd_identified_date: entry.pd_identified_date || visit.visit_date || "",
          date_of_occurrence: entry.date_of_occurrence || visit.visit_date || "",
          subject_no: entry.subject_no || this.getSelectedPatientCode(),
        }));
      }

      this.updatePdTrackerCount();
      this.pdModalOpen = true;
    },

    addPdRow() {
      if (!this.activePdVisit) {
        return;
      }

      this.pdDraftEntries.push(this.createPdEntry(this.activePdVisit));
      this.updatePdTrackerCount();
    },

    removePdRow(entryIndex) {
      if (!this.activePdVisit) {
        return;
      }

      this.pdDraftEntries.splice(entryIndex, 1);
      this.updatePdTrackerCount();
    },

    submitPdModal() {
      if (!this.activePdVisit) {
        this.pdModalOpen = false;
        return;
      }

      this.$set(this.activePdVisit, "rpd_entries", this.cloneEntries(this.pdDraftEntries));
      this.$set(this.activePdVisit, "rpd_tracker", this.pdDraftEntries.length);
      this.pdModalOpen = false;
    },

    resetPdDraft() {
      this.pdDraftEntries = [];
      this.activePdVisitIndex = null;
    },

    cloneEntries(entries) {
      return JSON.parse(JSON.stringify(Array.isArray(entries) ? entries : []));
    },

    applyPatientDates(patient) {
      const patientDates = [
        patient && patient.visit_date_1 ? patient.visit_date_1 : "",
        patient && patient.visit_date_2 ? patient.visit_date_2 : "",
        patient && patient.visit_date_3 ? patient.visit_date_3 : "",
        patient && patient.visit_date_4 ? patient.visit_date_4 : "",
        patient && patient.visit_date_5 ? patient.visit_date_5 : "",
      ];

      this.form.visits = this.form.visits.map((visit, index) => ({
        ...visit,
        visit_date:
          patientDates[index] &&
          (!visit.min_date || patientDates[index] >= visit.min_date) &&
          (!visit.max_date || patientDates[index] <= visit.max_date)
            ? patientDates[index]
            : "",
        validation_message: "",
      }));
    },

    validateVisitRow(index) {
      const visit = this.form.visits[index];

      if (!visit) {
        return true;
      }

      if (!visit.visit_date) {
        this.$set(visit, "validation_message", "");
        return true;
      }

      if (Array.isArray(visit.sae_entries) && visit.sae_entries.length) {
        visit.sae_entries = visit.sae_entries.map((entry) => ({
          ...entry,
          date_of_awareness: entry.date_of_awareness || visit.visit_date,
        }));
      }

      if (Array.isArray(visit.rpd_entries) && visit.rpd_entries.length) {
        visit.rpd_entries = visit.rpd_entries.map((entry) => ({
          ...entry,
          pd_identified_date: visit.visit_date || "",
          date_of_occurrence: entry.date_of_occurrence || visit.visit_date,
        }));
      }

      if ((visit.min_date && visit.visit_date < visit.min_date) || (visit.max_date && visit.visit_date > visit.max_date)) {
        this.$set(
          visit,
          "validation_message",
          `Visit Date must be between ${this.formatDate(visit.min_date)} and ${this.formatDate(visit.max_date)}.`
        );
        return false;
      }

      this.$set(visit, "validation_message", "");
      return true;
    },

    validateAllRows() {
      return this.form.visits.every((visit, index) => this.validateVisitRow(index));
    },

    async loadProjectOptions() {
      try {
        const { data } = await axios.get("/projectvisit/projectoptions", {
          headers: {
            Authorization: "Bearer " + this.access_token,
            "Content-type": "application/json",
          },
        });

        if (data.status === 200) {
          this.projectOptions = data.data || [];
        }
      } catch (error) {
        console.log(error.response || error);
        this.errorMessage = "Unable to load project list.";
      }
    },

    async loadPatientData() {
      this.patientOptions = [];
      if (!this.form.project_id) {
        return;
      }

      try {
        const { data } = await axios.get("/projectvisit/patientoptions?project_id=" + this.form.project_id, {
          headers: {
            Authorization: "Bearer " + this.access_token,
            "Content-type": "application/json",
          },
        });

        if (data.status === 200) {
          this.patientOptions = data.data || [];
        }
      } catch (error) {
        console.log(error.response || error);
        this.errorMessage = "Unable to load patient list.";
      }
    },

    async createPatient() {
      if (!this.form.project_id) {
        this.errorMessage = "Please select a project first.";
        return;
      }

      this.errorMessage = "";
      this.creatingPatient = true;

      try {
        const payload = {
          userid: this.userid,
          form: {
            project_id: this.form.project_id,
            site: this.form.site,
          },
        };

        const { data } = await axios.post("/projectvisit/createpatient", payload, {
          headers: {
            Authorization: "Bearer " + this.access_token,
            "Content-type": "application/json",
          },
        });

        if (data.status === 200 && data.data) {
          await this.loadPatientData();
          this.form.patient_id = String(data.data.id);
          this.handlePatientChange();
        } else {
          this.errorMessage = data.message || "Patient create failed.";
        }
      } catch (error) {
        console.log(error.response || error);
        this.errorMessage = "Patient create failed.";
      } finally {
        this.creatingPatient = false;
      }
    },

    async handleProjectChange() {
      this.previewMessage = "";
      this.errorMessage = "";
      this.form.patient_id = "";
      this.form.site = "";
      this.form.screening_date = "";
      this.form.report_batch_code = "";
      this.form.visits = [];
      this.projectDetails = {
        project_name: "",
        visit_schedule: [],
        investigator_names: [],
      };
      this.patientOptions = [];
      this.projectInvestigatorOptions = [];
      if (!this.form.project_id) {
        return;
      }

      try {
        const { data } = await axios.get("/projectmanagement/view?id=" + this.form.project_id, {
          headers: {
            Authorization: "Bearer " + this.access_token,
            "Content-type": "application/json",
          },
        });

        if (data.status !== 200) {
          this.errorMessage = data.message || "Unable to load selected project.";
          return;
        }

        const project = data.data || {};
        const visitSchedule = Array.isArray(project.visit_schedule) ? project.visit_schedule : [];

        this.projectDetails = project;
        this.form.site = project.site || "";
        this.form.screening_date = project.screening_date || "";
        this.form.report_batch_code = "";
        this.projectInvestigatorOptions = this.buildInvestigatorOptions(project.investigator_names);
        this.form.investigators = [...this.projectInvestigatorOptions];
        this.form.visits = visitSchedule.map((row, index) => this.buildVisitRow(row, index));
        await this.loadPatientData();

        if (!this.patientOptions.length) {
          await this.createPatient();
        }
      } catch (error) {
        console.log(error.response || error);
        this.errorMessage = "Unable to load selected project.";
      }
    },

    async handlePatientChange() {
      if (!this.form.patient_id) {
        this.form.site = this.projectDetails.site || "";
        this.form.screening_date = this.projectDetails.screening_date || "";
        this.form.report_batch_code = "";
        this.projectInvestigatorOptions = this.buildInvestigatorOptions(this.projectDetails.investigator_names);
        this.form.investigators = [...this.projectInvestigatorOptions];
        const baseSchedule = Array.isArray(this.projectDetails.visit_schedule) ? this.projectDetails.visit_schedule : [];
        this.form.visits = baseSchedule.map((row, index) => this.buildVisitRow(row, index));
        this.applyPatientDates(null);
        return;
      }

      const selectedPatient = this.patientOptions.find((item) => String(item.value) === String(this.form.patient_id));

      if (!selectedPatient) {
        return;
      }

      this.form.site = selectedPatient.site || this.projectDetails.site || "";
      this.form.screening_date = this.projectDetails.screening_date || "";

      try {
        const { data } = await axios.get(
          "/projectvisit/patientreport?project_id=" + this.form.project_id + "&patient_id=" + this.form.patient_id,
          {
            headers: {
              Authorization: "Bearer " + this.access_token,
              "Content-type": "application/json",
            },
          }
        );

        if (data.status === 200 && data.data && Array.isArray(data.data.visits) && data.data.visits.length) {
          this.form.site = data.data.site || this.form.site;
          this.form.screening_date = data.data.screening_date || this.form.screening_date;
          this.form.report_batch_code = data.data.report_batch_code || "";
          this.applyInvestigatorSelection(data.data.investigator_names || this.projectDetails.investigator_names || []);
          const baseSchedule = Array.isArray(this.projectDetails.visit_schedule)
            ? this.projectDetails.visit_schedule.map((row, index) => this.buildVisitRow(row, index))
            : [];
          this.form.visits = this.mergePatientVisits(baseSchedule, data.data.visits);
        } else {
          this.form.report_batch_code = "";
          this.projectInvestigatorOptions = this.buildInvestigatorOptions(this.projectDetails.investigator_names);
          this.form.investigators = [...this.projectInvestigatorOptions];
          const baseSchedule = Array.isArray(this.projectDetails.visit_schedule) ? this.projectDetails.visit_schedule : [];
          this.form.visits = baseSchedule.map((row, index) => this.buildVisitRow(row, index));
          this.applyPatientDates(selectedPatient);
        }
      } catch (error) {
        console.log(error.response || error);
        this.form.report_batch_code = "";
        this.projectInvestigatorOptions = this.buildInvestigatorOptions(this.projectDetails.investigator_names);
        this.form.investigators = [...this.projectInvestigatorOptions];
        const baseSchedule = Array.isArray(this.projectDetails.visit_schedule) ? this.projectDetails.visit_schedule : [];
        this.form.visits = baseSchedule.map((row, index) => this.buildVisitRow(row, index));
        this.applyPatientDates(selectedPatient);
      }

      this.form.visits = this.form.visits.map((visit) => ({
        ...visit,
        sae_entries: Array.isArray(visit.sae_entries)
          ? visit.sae_entries.map((entry) => ({
              ...entry,
              patient_number: entry.patient_number || selectedPatient.code || selectedPatient.label || "",
            }))
          : [],
        rpd_entries: Array.isArray(visit.rpd_entries)
          ? visit.rpd_entries.map((entry) => ({
              ...entry,
              subject_no: entry.subject_no || selectedPatient.code || selectedPatient.label || "",
            }))
          : [],
      }));
      this.validateAllRows();
    },

    async saveVisitReport() {
      this.previewMessage = "";
      this.errorMessage = "";

      if (!this.form.project_id) {
        this.errorMessage = "Please select a project.";
        return;
      }

      const enteredVisits = this.form.visits.filter((visit) => visit.visit_date);

      if (!enteredVisits.length) {
        this.errorMessage = "Please enter at least one Visit Date.";
        return;
      }

      if (!this.validateAllRows()) {
        this.errorMessage = "Please correct the Visit Date validation errors.";
        return;
      }

      this.saving = true;

      try {
        const payload = {
          userid: this.userid,
          form: {
            project_id: this.form.project_id,
            patient_id: this.form.patient_id,
            site: this.form.site,
            screening_date: this.form.screening_date,
            report_batch_code: this.form.report_batch_code,
            investigator_names: this.investigatorNames,
            visits: this.form.visits.map((visit) => ({
              visit_number: visit.visit_number,
              treatment_phase: visit.treatment_phase || "",
              treatment_phase_label: visit.treatment_phase_label || "",
              is_fixed_row: !!visit.is_fixed_row,
              description: visit.description,
              date: visit.date,
              allowed_deviation_days: visit.allowed_deviation_days,
              visit_date: visit.visit_date,
              sae_entries: visit.sae_entries || [],
              rpd_entries: visit.rpd_entries || [],
            })),
          },
        };

        const { data } = await axios.post("/projectvisit/create", payload, {
          headers: {
            Authorization: "Bearer " + this.access_token,
            "Content-type": "application/json",
          },
        });

        if (data.status === 200) {
          this.previewMessage = data.message || "Visit report saved successfully.";
          this.form.patient_id = data.patient_id ? String(data.patient_id) : this.form.patient_id;
          this.form.report_batch_code = data.report_batch_code || this.form.report_batch_code;
          const savedVisits = this.form.visits.map((visit) => ({
            ...visit,
            validation_message: "",
          }));
          this.form.visits = savedVisits;
          await this.loadPatientData();
          this.handlePatientChange();
        } else {
          this.errorMessage = data.message || "Visit report save failed.";
        }
      } catch (error) {
        console.log(error.response || error);
        this.errorMessage = "Visit report save failed.";
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style scoped>
.visit-schedule-banner {
  display: block;
  width: 100%;
  background: #0d6efd;
  color: #fff;
  border-radius: 2px;
  padding: 3px 8px;
  font-size: 14px;
  line-height: 1.2;
  margin-bottom: 0;
}
</style>

<style>
.modal-dialog.sae-fullscreen-modal {
  max-width: calc(100vw - 38px) !important;
  width: calc(100vw - 38px) !important;
  margin: 12px auto !important;
}

.modal-dialog.sae-fullscreen-modal .modal-content {
  height: calc(100vh - 200px);
  min-height: calc(100vh - 200px);
  border-radius: 12px;
  display: flex;
  flex-direction: column;
}

.modal-dialog.sae-fullscreen-modal .modal-header {
  flex: 0 0 auto;
}

.modal-dialog.sae-fullscreen-modal .modal-body {
  flex: 1 1 auto;
  overflow-x: auto;
  overflow-y: auto;
  padding-bottom: 24px;
}

.action-icon-btn {
  font-size: 16px;
  line-height: 1;
  text-decoration: none;
}

.tracker-card {
  border: 1px solid #d8e2ec;
  border-radius: 14px;
  background: #f8fbff;
  overflow: hidden;
}

.tracker-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  background: #eaf4ff;
  border-bottom: 1px solid #d8e2ec;
  font-size: small;
}

.tracker-card-body {
  padding: 14px;
  background: #ffffff;
}

.tracker-label {
  display: block;
  margin-bottom: 4px;
  font-size: 12px;
  font-weight: 600;
  color: #334e68;
}

.tracker-empty-state {
  border: 1px dashed #cbd5e1;
  border-radius: 14px;
  background: #f8fbff;
}

.investigator-list-box {
  border: 1px solid #ced4da;
  border-radius: 12px;
  background: #ffffff;
  padding: 10px 12px;
  min-height: 48px;
}

.investigator-list-item {
  font-size: small;
  line-height: 1.4;
  margin-bottom: 4px;
}

.investigator-list-item:last-child {
  margin-bottom: 0;
}

.investigator-remove-btn {
  font-size: 11px;
  padding: 2px 8px 2px 0;
  border: 0;
  color: #dc3545;
  text-decoration: none;
}

.activity-select >>> .vs__selected {
  display: none;
}

.activity-select >>> .vs__selected-options {
  overflow: hidden;
}

.activity-select >>> .vs__search {
  margin: 0 !important;
}
</style>
